// extracted by mini-css-extract-plugin
export default {"trade-panel__change":"+3a8x9a07upBDoVYSrgPhQ=="};